import * as Yup from 'yup';

// W-0663 — Validações do form de Acerto de Contas.
// Paridade Delphi UAcertacodigoconta.pas Edit1/Edit2/Edit4Exit.
export const acertarContaSchema = Yup.object().shape({
  codigoGe: Yup.number()
    .typeError('Selecione o Empreendimento')
    .required('Selecione o Empreendimento'),
  codigoOrigem: Yup.number()
    .typeError('Código atual deve ser numérico')
    .integer('Código atual deve ser inteiro')
    .min(1, 'Código atual inválido')
    .required('Código atual é obrigatório'),
  codigoDestino: Yup.number()
    .typeError('Novo código deve ser numérico')
    .integer('Novo código deve ser inteiro')
    .min(1, 'Novo código inválido')
    .required('Novo código é obrigatório')
    .test(
      'different-from-origem',
      'Novo código deve ser diferente do atual',
      function (value) {
        const origem = this.parent.codigoOrigem;
        if (value == null || origem == null || origem === '') return true;
        return Number(value) !== Number(origem);
      }
    ),
  codigoCentroCusto: Yup.number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value
    )
    .typeError('CC deve ser numérico')
    .integer('CC deve ser inteiro')
    .min(1, 'CC inválido')
    .nullable(),
});
